import { useMemo } from 'react';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, LOGS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @yusufyldrm
 */

const PickUpRequestLogList = () => {
	const defaultSort = useMemo(() => [{ id: 'createdDate', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 70,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'otoOrderID',
				accessor: 'otoOrderID',
				filterType: FilterType.number,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'pickupId',
				accessor: 'pickupId',
				filterType: FilterType.string,
				showCopyButton: true
			},
			{
				Header: 'createdDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'shipmentNumber',
				accessor: 'shipmentId',
				filterType: FilterType.string,
				showCopyButton: true
			},
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryCompany',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DELIVERY_COMPANIES
			},
			{
				Header: 'message',
				accessor: 'message',
				filterType: FilterType.string
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ALL_STATUSES,
				renderCell: ListComponents.STATUS,
				showOnMobile: true
			},
			{
				Header: 'logStatus',
				accessor: 'logStatus',
				filterType: FilterType.enum,
				enumName: ENUMS.SUCCESS_FAILURE,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.PICKUP_REQUEST_LOGS}
				columns={columns}
				fetchUrl={LOGS.GET_PICKUP_REQUEST_LIST}
				defaultSort={defaultSort}
				exportName="pickUpRequestLog"
				infiniteScroll
			/>
		</TabTableContainer>
	);
};

export default PickUpRequestLogList;
